import axios from 'axios';
import { makeGetSiteFeaturesUrl } from '../utils/urlProvider';

class SiteFeatureApi {
    getSiteFeatures = query => (
      axios({
        method: 'GET',
        url: makeGetSiteFeaturesUrl(query),
        withCredentials: true,
      })
    )
}

export default new SiteFeatureApi();
